const MUTATE_SYSCLOCK = 'mutateSysClock'
const MUTATE_JOB_RUNNING = 'mutateJobRunning'
const MUTATE_LOGGEDIN = 'mutateLoggedIn'

const state = {
  sysClock: null,
  jobRunning: false,
  loggedIn: false
}

const getters = {
  sysClock: (state) => state.sysClock,
  jobRunning: (state) => state.jobRunning,
  loggedIn: (state) => state.loggedIn
}

const mutations = {
  mutateSysClock (state, time) {
    state.sysClock = time
  },
  mutateJobRunning (state, bool) {
    state.jobRunning = bool
  },
  mutateLoggedIn (state, bool) {
    state.loggedIn = bool
  }
}

const actions = {
  setSysClock ({commit}, time) {
    commit(MUTATE_SYSCLOCK, time)
  },
  setJobRunning ({commit}, bool) {
    commit(MUTATE_JOB_RUNNING, bool)
  },
  setLoggedIn ({ commit }, bool) {
    commit(MUTATE_LOGGEDIN, bool)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}